import { TerminalByLocationLoaderInterface } from './interface';
import { TerminalByLocationLoader } from './TerminalByLocationLoader';

// Фабрика сервиса
export const terminalByLocationLoader: {
  (token?: string): TerminalByLocationLoaderInterface;
} = (token) => new TerminalByLocationLoader(token);
